/* ----------------- Components --------------- */
import Box from "../../Box";
import { Skeleton } from "../../Skeleton";

export const StatsSkeleton = ({
	numRows = 3,
}: {
	numRows?: number;
}) => {
	return (
		<Box
			flexDirection="row"
			flexWrap="wrap"
			gap={24}
			justifyContent="center"
			paddingVertical={16}
		>
			{[...new Array(numRows).keys()].map((item) => {
				return (
					<Box key={item} alignItems="center" maxWidth={120}>
						<Skeleton variant="circle" size={24} />
						<Box height={16} justifyContent="center">
							<Skeleton width={48} height={12} />
						</Box>
						<Box height={14} justifyContent="center">
							<Skeleton width={72} height={10} />
						</Box>
					</Box>
				);
			})}
		</Box>
	);
};
